<template>
  <section ref="strip" class="s-branchlocator">
    <div class="s-branchlocator__conts">
      <Loader v-if="isLoading" display="absolute"></Loader>
      <Alert
        v-if="errorMsgs.length"
        type="danger"
        :messages="errorMsgs"></Alert>

      <div class="s-branchlocator__ribbon">
        <!-- Filters -->
        <div class="s-branchlocator__ribbon__filters">
          <div class="form-group">
            <div class="input-wrap">
              <select
                v-model="country"
                class="form-select"
                @change="onChangeCountry">
                <option
                  v-for="item in countries"
                  :key="item.value"
                  :value="item.value">
                  {{ item.text }}
                </option>
              </select>
            </div>
            <div class="input-wrap">
              <select v-model="city" class="form-select" @change="onChangeCity">
                <option value="">{{ dictionary.cityPlaceholder }}</option>
                <option
                  v-for="item in cities"
                  :key="item.value"
                  :value="item.value">
                  {{ item.text }}
                </option>
              </select>
            </div>
            <div class="input-wrap">
              <select
                v-model="location"
                class="form-select"
                @change="onChangeLocation">
                <option value="">
                  {{ dictionary.locationPlaceholder }}
                </option>
                <option
                  v-for="item in locations"
                  :key="item.value"
                  :value="item.value">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- View -->
        <div class="s-branchlocator__ribbon__view">
          <nav class="b-nav-like-tabs b-nav-like-tabs--fontsmall">
            <ul>
              <li>
                <a
                  :class="{ 'is-active': viewTypeIsMap }"
                  @click="setViewTypeAsMap">
                  {{ dictionary.viewMapLabel }}
                </a>
              </li>
              <li>
                <a
                  :class="{ 'is-active': viewTypeIsList }"
                  @click="setViewTypeAsList">
                  {{ dictionary.viewListLabel }}
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div v-show="viewTypeIsList" class="s-branchlocator__view-list">
        <div v-if="recordsCountFiltered" class="s-branchlocator__results mb-40">
          <div
            v-for="item in recordsFilteredPaged"
            :key="item.code"
            class="s-branchlocator__item">
            <Store :item="item" />
          </div>
        </div>

        <div v-if="!recordsCountFiltered">
          <NoResults></NoResults>
        </div>

        <div v-if="recordsCountFiltered" class="d-flex justify-content-center">
          <Pagination
            :total-records="recordsCountFiltered"
            :per-page="itemsPerPage"
            :current-page="page"
            @pagechanged="pageChanged" />
        </div>
      </div>

      <div v-show="viewTypeIsMap" class="s-branchlocator__view-map">
        <div id="map" ref="map"></div>

        <div v-if="selectedRecord">
          <Store
            :item="selectedRecord"
            :show-close-button="true"
            @clear-selected-record="clearselectedRecord" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import jQuery from 'jquery'
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import NoResults from '../components/common/NoResults.vue'
import Pagination from './../components/common/Pagination.vue'
import * as lib from '../../lib/lib'
import { v4 as uuidv4 } from 'uuid'
import Store from './../components/Store.vue'
import constants from './../../lib/constants'
/* eslint-disable no-unused-vars */
import { head, uniqBy } from 'lodash'

const _markers = []
let _map = null

export default {
  components: { Loader, Alert, NoResults, Pagination, Store },
  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      countries: [],
      country: '',
      city: '',
      locations: [],
      location: '',
      viewType: constants.stores.view.map,
      page: 1,
      pageSize: 9,
      itemsPerPage: 0,

      records: [],
      recordsCount: null,
      recordsFiltered: [],
      recordsInBound: [],
      selectedRecord: null,

      // Map properties
      defaultZoom: 15,
      mapId: 'map',
      map: null,
      bounds: null,
      markers: [],
      markersInBound: [],
      mapIcon: '/imgs/misc/GoogleMapsMarker.png',
      scrollOffsetY: lib.scrDesktops() ? 100 : 120,
    }
  },

  computed: {
    viewTypeIsMap() {
      return this.viewType === constants.stores.view.map
    },

    viewTypeIsList() {
      return this.viewType === constants.stores.view.list
    },

    cities() {
      const arr = this.records.map((x) => ({
        text: x.city,
        value: x.city,
      }))

      /* eslint-disable no-undef */
      return _.uniqBy(arr, 'value')
    },

    recordsFilteredPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage

      return this.recordsFiltered.slice(start, end)
    },

    recordsCountFiltered() {
      return this.recordsFiltered.length
    },
  },

  mounted() {
    const { countries } = lib.getData('storesData')

    this.countries = countries
    this.itemsPerPage = this.configuration.itemsPerPage
    this.setPreselectedValues()

    const countryParam = lib.getUrlParam('country', '')

    if (countryParam) {
      this.country = countryParam
    }

    document.addEventListener('google-map-ready', () => {
      this.fetchData()
    })
  },

  methods: {
    iniGoogleApps() {
      this.iniMap()
    },

    iniMap() {
      const google = window.google

      const element = document.getElementById(this.mapId)

      if (element === null) {
        return false
      }

      const options = {
        mapTypeControl: false,
        fullScreenControl: false,
        styles: this.optionsStylesMap,
      }
      this.map = _map = new google.maps.Map(element, options)

      this.records.forEach((i) => {
        const _position = new google.maps.LatLng(i.longitude, i.latitude)

        const marker = new google.maps.Marker({
          position: _position,
          map: this.map,
          icon: this.mapIcon,
          id: i.code,
          title: `${i.address}, ${i.city}`,
        })

        // DO NOT REMOVE helping variable '_markers'
        // new MarkerClusterer method does not accept a vue.js data property as a parameter
        _markers.push(marker)
        this.markers.push(marker)

        marker.addListener('click', () => {
          this.map.setZoom(
            this.map.getZoom() > this.defaultZoom
              ? this.map.getZoom()
              : this.defaultZoom
          )

          this.map.setCenter(marker.getPosition())
          this.selectedRecord = this.records.find((i) => i.code === marker.id)
          this.setFiltersByRecord()
          lib.scrollToElem(jQuery(this.$refs.strip), this.scrollOffsetY)
        })
      })

      this.fitBoundsToMarkers()
    },

    fitBoundsToMarkers() {
      this.bounds = new google.maps.LatLngBounds()
      this.markers.forEach((i) => {
        if (i.visible) {
          this.bounds.extend(i.position)
        }
      })
      this.map.fitBounds(this.bounds)
    },

    setFiltersByRecord() {
      const { city, address } = this.selectedRecord

      this.city = city
      this.locations = this.recordsFiltered
        .filter((i) => i.city === this.city)
        .map((x) => ({
          text: x.address,
          value: x.address,
        }))

      this.location = address
    },

    clearselectedRecord() {
      this.selectedRecord = null
    },

    setViewTypeAsMap() {
      this.viewType = constants.stores.view.map
    },

    setViewTypeAsList() {
      this.viewType = constants.stores.view.list
    },

    setPreselectedValues() {
      const entry = this.countries.find((i) => i.selected)
      this.country = entry ? entry.value : ''
    },

    fetchData() {
      this.isLoading = true

      const formData = new FormData()

      formData.append('countryCode', this.country)
      axios
        .post(this.configuration.endpointFetchData, formData)
        .then((response) => {
          const data = response.data

          this.records = this.recordsFiltered = data
            .map((i) => i.Locations)
            .flat()
          this.recordsCount = this.records.length
          this.key = uuidv4()

          this.iniGoogleApps()
          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    pageChanged(value) {
      this.page = value
      lib.scrollToElem(jQuery(this.$refs.strip), 100)
    },

    setViewType(type) {
      this.viewType = type

      if (this.viewType === constants.stores.view.map) {
        this.initMap()
      }
    },

    onChangeCountry() {
      this.page = 1
      this.cities = []
      this.city = ''
      this.locations = []
      this.location = ''
      this.selectedRecord = null
      this.fetchData()
    },

    onChangeCity() {
      this.page = 1
      this.locations = []
      this.location = ''
      this.selectedRecord = null

      if (!lib.hasValue(this.city)) {
        this.recordsFiltered = this.records
        this.locations = []

        this.setVisibleMarkers()
        this.fitBoundsToMarkers()
        return false
      }

      this.recordsFiltered = this.records.filter((i) => i.city === this.city)
      this.locations = this.recordsFiltered.map((x) => ({
        text: x.address,
        value: x.address,
      }))

      this.setVisibleMarkers()
      this.fitBoundsToMarkers()
    },

    onChangeLocation() {
      this.page = 1

      if (!lib.hasValue(this.location)) {
        this.recordsFiltered = this.records.filter((i) => i.city === this.city)
        this.setVisibleMarkers()
        this.fitBoundsToMarkers()
        return false
      }

      this.recordsFiltered = this.records.filter(
        (i) => i.city === this.city && i.address === this.location
      )

      this.selectedRecord = _.head(this.recordsFiltered)
      this.setVisibleMarkers()
      this.fitBoundsToMarkers()
    },

    setVisibleMarkers() {
      _markers.forEach((marker) => {
        const visible = this.recordsFiltered.some((x) => x.code === marker.id)
        marker.setVisible(visible)
      })
    },
  },
}
</script>
